import React from 'react'

export default function Eye() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 9.375C11.25 9.375 8.0475 11.7075 6.75 15C8.0475 18.2925 11.25 20.625 15 20.625C18.75 20.625 21.9525 18.2925 23.25 15C21.9525 11.7075 18.75 9.375 15 9.375ZM15 18.75C12.93 18.75 11.25 17.07 11.25 15C11.25 12.93 12.93 11.25 15 11.25C17.07 11.25 18.75 12.93 18.75 15C18.75 17.07 17.07 18.75 15 18.75ZM15 12.75C13.755 12.75 12.75 13.755 12.75 15C12.75 16.245 13.755 17.25 15 17.25C16.245 17.25 17.25 16.245 17.25 15C17.25 13.755 16.245 12.75 15 12.75Z" fill="#605C5C" />
    </svg>
  )
}
